<div class="bg-white px-4">
    <header class="mb-10 flex items-center px-8 pt-10">
        <div class="flex items-center">
            <mat-icon class="mr-5 scale-150">integration_instructions</mat-icon>
            <h1 class="text-3xl font-medium">Templates</h1>
        </div>
    </header>
    @if (templatesStore.isFulfilled()) {
        <mat-form-field class="w-full">
            <mat-label>Search</mat-label>
            <input
                matInput
                (keyup)="applyFilter($event)" />
        </mat-form-field>
        <button
            mat-flat-button
            color="primary"
            routerLink="/{{ ComponentRoutes.quests.template.replace(':templateId', '0') }}">
            Add template
        </button>
        <table
            mat-table
            [dataSource]="dataSource"
            matSort
            matSortActive="name"
            matSortDirection="asc"
            matSortDisableClear>
            <ng-container matColumnDef="name">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header>
                    Name
                </th>
                <td
                    mat-cell
                    *matCellDef="let element">
                    <div class="flex items-center">
                        {{ element.name }}
                    </div>
                </td>
            </ng-container>
            <ng-container matColumnDef="triggerType">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header>
                    Trigger type
                </th>
                <td
                    mat-cell
                    *matCellDef="let element">
                    {{ QuestTriggerType[element.triggerType] }}
                </td>
            </ng-container>
            <ng-container matColumnDef="conditionType">
                <th
                    mat-header-cell
                    *matHeaderCellDef>
                    Condition type
                </th>
                <td
                    mat-cell
                    *matCellDef="let element">
                    {{ QuestConditionType[element.conditionType] }}
                </td>
            </ng-container>
            <ng-container matColumnDef="actions">
                <th
                    mat-header-cell
                    *matHeaderCellDef></th>
                <td
                    mat-cell
                    *matCellDef="let element">
                    <button
                        mat-button
                        [matMenuTriggerFor]="menu">
                        Manage
                    </button>
                    <mat-menu #menu="matMenu">
                        <button
                            mat-menu-item
                            routerLink="/{{
                                ComponentRoutes.quests.template.replace(':templateId', element.id)
                            }}">
                            Edit template
                        </button>
                    </mat-menu>
                </td>
            </ng-container>
            <tr
                mat-header-row
                *matHeaderRowDef="displayedColumns()"></tr>
            <tr
                mat-row
                *matRowDef="let row; columns: displayedColumns()"></tr>
        </table>
    }
</div>
